import { IonCol, IonGrid, IonIcon, IonPage, IonRow, IonText } from '@ionic/react';
import React, { useEffect } from 'react';
import './userProfile.scss';
import { getUserFields } from './userProfileUtil';
import { Persona } from '../../components/persona/persona';
import { Breadcrumb } from '../../../web/components/breadcrumb/Breadcrumb';
import { PAGE_TITLES } from '../../../utils/constants';
import { EVENT, SCREEN } from '../../../utils/constants.analytics';
import { logEvent, setScreenName } from '../../../utils/Analytics';
import { isEntitled } from 'app/utils/common';

export const UserProfile: React.FC<any> = (props: any) => {

    const { userDetails, history } = props;
    const roles = userDetails?.memberDetailsResponse?.member?.userApplicationDetails[0].roles &&
    userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles.map((item: any) => item.roleName)

    const selectedUserData = history && history.location && history.location.state &&
        history.location.state.selectedUser ?
        history && history.location && history.location.state && history.location.state.selectedUser
        : { ...userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member, roles }
    const title = history && history.location && history.location.state && history.location.state.title || PAGE_TITLES.MYPROFILE;

    const fullName = (history?.location?.state?.selectedUser) ?
        `${history?.location?.state?.selectedUser?.firstName || ''} ${history?.location?.state?.selectedUser?.lastName || ''}` :
        `${userDetails?.memberDetailsResponse?.member?.firstName || ''} ${userDetails?.memberDetailsResponse?.member?.lastName || ''}`

    const isSelf = () => {
        if (history?.location?.state?.selectedUser && userDetails) {
            return userDetails?.memberDetailsResponse?.member?.upn === (history?.location?.state?.selectedUser?.upn || history?.location?.state?.selectedUser?.userPrincipalName)
        }
        return false;
    }
    useEffect(() => {
        if (title === PAGE_TITLES.MYPROFILE) {
            // Analytics implementation
            setScreenName("screen_my_profile")
            logEvent(EVENT.SV_VIEW_MY_PROFILE,
                {
                    screen: SCREEN.MY_PROFILE,
                    carrierId: userDetails && userDetails.memberDetailsResponse &&
                    userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId
                });
        }
    }, []);

    return <>
        <IonPage className="desktop-page myloads-page">
            <div className="my-profile-header">
                {title === "View Profile" &&
                    <Breadcrumb items={[{ name: "Manage Users", backUrl: "/app/manage/ManageUser" }, { name: "View Profile", backUrl: '' }]} />
                }
                <h1 className="my-profile-title" data-testid="myProfileTitle">{title}</h1>
            </div>
            <IonGrid className="profile-page-grid profile-page-web">
                <IonRow class="top-row">
                    <IonCol class="name-col">
                        <IonText>
                            {fullName}
                        </IonText>
                    </IonCol>

                   {(isEntitled('manage', 'manageUsersEdit') || title === PAGE_TITLES.MYPROFILE || isSelf()) && <IonCol class="edit-col" size="1.5" size-lg="1">
                        <IonRow
                            className="edit-cursor-pointer"
                            data-testid="editUserProfile"
                            onClick={() => history.push('/app/userProfile/edit', {
                                isEdit: true,
                                selectedUser: selectedUserData,
                                isSelf: isSelf()
                            })}>
                            <IonCol>
                                <IonIcon className="edit-icon" src="assets/icon/Edit-Orange.svg" />
                                <IonText className="edit-text">Edit</IonText>
                            </IonCol>
                        </IonRow>
                    </IonCol>}

                </IonRow>
                <IonRow>
                    <IonCol size="4">
                        <IonRow class="user-profile-icon">
                            <Persona
                                viewProfile={true}
                                name={fullName}
                                showName={false}
                            />
                        </IonRow>
                    </IonCol>
                    <IonCol size="8">
                        {getUserFields(selectedUserData)}
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonPage>
    </>
}